import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Breadcrumb } from '../../_models/breadcrumb.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-bread-crumbs',
        standalone: true,
templateUrl: './bread-crumbs.component.html',
    styleUrls: ['./bread-crumbs.component.scss'],
    imports: [RouterLink, NgStyle, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadCrumbsComponent implements OnInit, OnDestroy {
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() isDark: boolean = false;
  @Input() isArrow: boolean = false;
  @Input() paddingLeft = '60px';
  @Input() paddingRight = '0px';
  @Input() paddingTop = '20px';
  @Input() paddingBottom = '0px';
  @Input() justify = 'left';

  private langChangeSub?: Subscription;

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Re-render when language changes
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  isRouterLink(url: string): boolean {
    // Adjust this condition to match your routing rules
    return url.startsWith('/');
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }
}
